import { render, staticRenderFns } from "./AdditionalSettingsCard.vue?vue&type=template&id=237d56f8"
import script from "./AdditionalSettingsCard.vue?vue&type=script&lang=js"
export * from "./AdditionalSettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports